import React from 'react';
import StudentLogin from './StudentLogin';
import OpenFromMyIMS from './OpenFromMyIMS';

// The PIN/paste form is a developer tool. Real students arrive via a MyIMS
// deep link (token in the URL) and never see `/`. Render the form ONLY on
// localhost; everywhere else show the static "open from MyIMS" panel, or a
// session-expired panel when a token existed but failed validation.
const isLocalhost = ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);

const HomePage = ({ onStudentLogin, authFailed }) => {
  if (isLocalhost) return <StudentLogin onStudentLogin={onStudentLogin} />;
  if (authFailed) return <SessionExpired />;
  return <OpenFromMyIMS />;
};

// A token existed but failed validation — tell the student how to get back in.
const SessionExpired = () => (
  <div className="min-h-screen flex items-center justify-center p-4 bg-slate-50">
    <div className="bg-white rounded-xl shadow-lg max-w-md w-full p-8 text-center">
      <h1 className="text-xl font-bold text-gray-800 mb-2">Your session has expired</h1>
      <p className="text-gray-600">
        Please open this report again from the AI Insights link inside MyIMS.
      </p>
    </div>
  </div>
);

export default HomePage;
